























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from '../store/textToVideo';
import { uploadImageToOss } from '@/views/videoEditor/utils/utils';
import { toast } from "@/utils/util";
import { checkImgContent } from '@/utils/utils';
import to from 'await-to-js';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class ImageToStory extends Vue {

  @Prop({ default: false })
  show: boolean;
  @Prop({ default: '' })
  text: string;
  @Prop({ default: null })
  imgs: any;

  imgUrl: string = '';
  resultText: string = '';
  generateStatus: string = 'empty';
  generateMessage: string = '正在生成中…';
  generateTimer = null;

  get imageUrls() { // 图片理解支持多张图片，目前只做了一张的
    return [this.imgUrl];
  }

  @Watch('text')
  async listenText(val) {
    if (this.show) {
      this.resultText = val;
      if(!val) {  // 清空
        this.generateStatus = 'empty';
        this.imgUrl = '';
      }
    }
  }

  mounted() {
    if(this.imgs && this.imgs.length) {
      this.imgUrl = this.imgs[0];
    }
    if(this.show) {
      this.generateStatus = 'success';
      this.resultText = this.text;
    }
  }

  /**
   * 选择图片点击事件
   */
  selectFileClick() {
    // 未登录时跳转登录页
    const ww_token = localStorage.getItem('ww_token');
    if (!ww_token) {
      this.$emit('login');
      return;
    }
    if(this.generateStatus === 'loading') return; // 正在生成文案禁止选择图片
    (this.$refs.uploadRef as HTMLElement).click()
  }
  /**
   * 选择图片文件上传
   * @param event
   */
  async selectFileImg(event) {
    const file = event.target.files[0];
    (this.$refs.uploadRef as any).value = '';
    // 上传文件到 oss
    const [uploadError, url] = await to(uploadImageToOss(file));
    if(uploadError || typeof url !== 'string') {
      return toast('图片上传失败');
    }
    const checkRes = await checkImgContent(this, { image: url });
    if (checkRes) return;

    this.imgUrl = url;
    this.generateImgToStory();
  }

   /**
   * 将图片生成故事
   */
  async generateImgToStory() {
    if(this.generateStatus === 'loading') return;
    this.generateMessage = '正在解析图片…';
    this.generateStatus = 'loading';
    this.resultText = '';

    // 图片理解
    const [understandError, understandRes] = await to(this.$http('understandImage', {
      imageUrls: [this.imgUrl]
    }));
    const understandData = understandRes && understandRes.data && understandRes.data.choices && understandRes.data.choices[0] || {};
    const understandContent = understandData.message && understandData.message.content;
    if(understandError || !understandContent) {
      this.generateStatus = 'error';
      const message = understandRes && understandRes.message;
      return toast(message || '图片理解失败');
    }
    
    this.generateMessage = '正在生成故事…';
    // 生成故事
    const [storyError, storyRes] = await to(this.$http('asyncGenerateStory', {
      content: understandContent
    }));
    const storyData = storyRes && storyRes.data || {};
    const taskId = storyData.task_id
    if(storyError || !taskId) {
      this.generateStatus = 'error';
      const message = storyData.message || (storyRes && storyRes.message);
      return toast(message || '生成故事失败');
    }

    this.getGenerateResult(taskId);
  }

  async getGenerateResult(id) {
    clearTimeout(this.generateTimer);
    const [storyError, storyRes] = await to(this.$http('getStoryResult', {
      taskId: id
    }));
    const storyData = storyRes && storyRes.data || {};
    if(storyData.status === 'waiting') {
      this.generateTimer = setTimeout(() => {
        this.getGenerateResult(id);
      }, 3000);
      return;
    }
    const resultText = storyData.results && storyData.results.results_list && storyData.results.results_list[0];
    if(storyError || storyData.status === 'fail' || !resultText) {
      this.generateStatus = 'error';
      const message = storyData.message || (storyRes && storyRes.message);
      return toast(message || '生成故事失败');
    }
    this.generateStatus = 'success';
    this.resultText = resultText;
    this.setResultText();
  }
  onBlur() {
    this.setResultText();
  }
  setResultText() {
    this.$emit('set-text', this.resultText, true);
  }

}
